module.exports = __webpack_public_path__ + "img/product_77.6b599da.svg";